module.exports = __webpack_public_path__ + "img/Optimized-Image.a42c42e7.png";